module.exports = __webpack_public_path__ + "static/media/NCUA-Badge.ff545740.svg";